import React, { useEffect } from "react";
import { navigate } from "gatsby";

// Components
// import { linkResolver } from "../link-resolver/linkResolver";

export const LanguageSwitcher = ({
  currentLanguage,
  setCurrentLanguage,
  location,
}) => {
  useEffect(() => {
    if (location.pathname.includes(`/fr/`) && currentLanguage !== `fr`) {
      setCurrentLanguage(`fr`);
    }
  }, [location]);

  const handleNavigation = (language) => {
    if (language === `en`) {
      if (location.pathname === `/fr/`) {
        const newPathname = location.pathname.replace("/fr/", "/");
        navigate(newPathname);
      } else {
        const newPathname = location.pathname.replace("fr", "en");
        navigate(newPathname);
      }
    } else {
      if (location.pathname === `/`) {
        const newPathname = location.pathname.replace("/", "/fr/");
        navigate(newPathname);
      } else {
        const newPathname = location.pathname.replace("en", "fr");
        navigate(newPathname);
      }
    }
  };

  // A single button, showing the language you switch TO — not the current one.
  const targetLanguage = currentLanguage === `fr` ? `en` : `fr`;

  return (
    <li className="language-switcher">
      <button
        className={`${targetLanguage}-toggle gotham-bold`}
        aria-label={
          targetLanguage === `en` ? `Switch to English` : `Passer en français`
        }
        onClick={() => {
          setCurrentLanguage(targetLanguage);
          handleNavigation(targetLanguage);
        }}
      >
        {targetLanguage.toUpperCase()}
      </button>
    </li>
  );
};
